import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { ProjectDetailsComponent } from '../project-details.component';

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard
  
{
  public static readonly ACTION_DISCARD = 'discard';
  public static readonly ACTION_SAVE = 'save';

  constructor(private dialog: MatDialog) {}

  canDeactivate(
    component: ProjectDetailsComponent
  ): boolean | Promise<boolean> {
    if (component.hasUnsavedChanges()) {
      const dialogObservable = this.dialog
        .open(ConfirmDialogComponent, {
          hasBackdrop: true,
          closeOnNavigation: false,
          data: {
            title: 'Unsaved Changes',
            message:
              'You have unsaved changes on this tab. What do you want to do?',
            actions: [
              {
                id: UnsavedChangesGuard.ACTION_DISCARD,
                label: 'Discard',
                tooltip: 'Discards the changes & leaves the tab',
                disabled: false,
                flair: 'negative',
              },
              {
                id: 'abort',
                label: 'Stay',
                tooltip: 'Returns to the tab with unsaved changes',
                disabled: false,
                flair: 'neutral',
              },
              {
                id: UnsavedChangesGuard.ACTION_SAVE,
                label: 'Save',
                tooltip: 'Saves the changes & leaves the tab',
                disabled: component.isSaveDisabled(),
                flair: 'positive',
              },
            ],
          },
        })
        .afterClosed();

      return firstValueFrom(dialogObservable).then(async (value) => {
        if (value === UnsavedChangesGuard.ACTION_DISCARD) {
          return true;
        } else if (value === UnsavedChangesGuard.ACTION_SAVE) {
          return await component.onSaveClicked();
        }
        return false;
      });
    }
    return true;
  }
}
